module.exports = __webpack_public_path__ + "hg-hangyodon.json";